<template>
    <div v-show="!hideSection" class="combo-list-wrapper">
        <p v-if="comboListData" class="list-title"> {{kStrings.kAVAILABLE_BUNDLES}} </p>
        <div v-if="comboListData" class="combo-list" id="sideCombosBox">
            <combo-item  v-for="combo in comboListData" :combo="combo" @comboClick="comboClick" />
            <transition name="fade">
                <!-- detail fs modal -->
                <BlockContentPopup
                    v-if="comboDetailData"
                    id="blockContentPopup"
                    class="combo-content-popup"
                    :header-title="kStrings.kCHOOSE_YOUR_PRODUCTS_OPTIONS"
                    :modal-mode="true"
                    :stacked-modal="true"
                    @close="closeModal()"
                >
                    <template v-slot:content>
                        <ComboDetail v-if="comboDetailData"
                                     :combo-id="comboDetailData.id"
                                     :price="comboDetailData.price"
                                     :price-crossed="comboDetailData.priceCrossed"
                                     :blocks-color=blocksColor
                                     context="PDP"
                                     @close="closeModal()"
                        />
                    </template>
                </BlockContentPopup>
            </transition>
        </div>
    </div>
</template>
<script>

import {storePdp} from '@/store/product-page';
//import pdpEvents from '@/Utilities/events-pdp/events';
import {isEmpty} from "lodash-es";
import MuffinLoader from "@/components/Muffin/Loader.vue";
import ComboItem from "@/components//ProductPage/ComboItem.vue";
import Mub from "@/components/Mub.vue";

export default {
    storePdp,
    name: 'ComboList',
    components:{
        BlockContentPopup: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/BlockContentPopup.vue'),
        ComboDetail: () => ({
            component: import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/ComboDetail.vue'),
            loading: MuffinLoader,
            delay: 200,
            timeout: 3000
        }),
        Mub,
        ComboItem
    },
    props: {
        loadOnCreate: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return{
            loading: false,
            comboDetailData: null, // cpg details modal
        }
    },
    created() {
        if(this.loadOnCreate && this.canCheckCombos){
            this.load();
        }
    },
    watch: {
        comboListData(val) {
            if(val && val.length) {
                this.$emit('loaded', true);
            }

            this.$emit('sideScrollListener', val && val.length);
        }
    },
    computed: {
        groupId() {
            return storePdp.getters.GroupId;
        },
        kStrings() {
            return storePdp.getters.kStrings;
        },
        blocksColor() {
            let blocksColor = storePdp.getters.blocksColor;
            if(!blocksColor) { // just in case
                return '#333';
            }

            return blocksColor;
        },
        canCheckCombos() {
            return storePdp.getters['pdpDesktop/canCheckCombos'];
        },
        comboListData() {
            if(!this.canCheckCombos){
                return null;
            }

            let comboData   = storePdp.getters['pdpDesktop/comboData'];
            let bundlesList = comboData?.bundlesList??[];
            if(bundlesList.length == 0) {
                return null;
            }


            let bundles = [];
            bundlesList.forEach((obj) => {
                if(obj?.bundle){
                    bundles.push(obj.bundle);
                }
            });

            return bundles;
        },
        hideSection() {
            return isEmpty(this.comboListData);
        }
    },
    methods: {
        async load() {
            this.loading = true;
            await storePdp.dispatch('pdpDesktop/updateComboData', {id: this.groupId, blocksColor: this.blocksColor, limit: 1000});
            this.loading = false;
            this.$emit('loaded', true);
        },
        closeModal() {
            this.comboDetailData = null;
            this.$emit('close-fp');
        },
        comboClick(combo){
            this.comboDetailData = combo;
            this.$emit('open-fp');
        }
    },
    filters: {
        strippedContent: function(string) {
            return string ? string.replace(/<\/?[^>]+>/ig, " ") : ''; 
        }
    },
}
</script>
<style lang="scss">
@import "./styles/comboList";
</style>
